<script>
  import axios from 'axios';
  import AS from '@/services/AuthenticationService';

  export default {
    fetch(cpfCnpj) {
      return axios.get(`utils/fetch_cpf_cnpj/${ cpfCnpj }`, AS.getDefaultHeaders());
    },
    async fetchDataFromReceita(cnpj) {
      const response = await axios.get(`utils/fetch_cnpj/${ cnpj }`, AS.getDefaultHeaders())
      return response.data;
    },
    async create(entity) {
      const entityRequest = {
        person: {
          name: entity.name,
          cpf_cnpj: entity.cpf_cnpj,
          email: entity.email,
          enquadramento: entity.enquadramento,
          address_attributes: {
            zip_code: entity.address.zip_code,
            street: entity.address.street,
            number: entity.address.number,
            complement: entity.address.complement,
            neighborhood: entity.address.neighborhood,
            city_id: entity.address.city.id,
            federal_unit_id: entity.address.federal_unit.id,
          },
        },
      };
      const response = await axios.post('pessoas', entityRequest, AS.getDefaultHeaders());
      return response.data
    },
    update({ id, address_attributes, name, email, enquadramento }) {
      address_attributes.city_id = address_attributes.city.id;
      address_attributes.federal_unit_id = address_attributes.federal_unit.id;

      const entityRequest = {
        person: {
          address_attributes,
          name,
          email,
          enquadramento
        }
      };

      return axios.put(`pessoas/${id}`, entityRequest, AS.getDefaultHeaders());
    }
  };
</script>
